export const formatDate = (date) => {
  const d = new Date(date || new Date());
  const day = d.toLocaleDateString("en-GB", { day: "2-digit" });
  const month = d.toLocaleDateString("en-GB", { month: "short" });
  const year = d.toLocaleDateString("en-GB", { year: "numeric" });
  return `${day} ${month}, ${year}`;
};
